<template>
    <div>
        <div class="simple-form">
            <el-form :model="reservedInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">外部付款凭证号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="reservedPayNo" :rules="{validator: checkNullModel, trigger: 'blur'}">
                            <el-input v-model="reservedInfo.reservedPayNo" class="width-2x" type="text"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">外部付款凭证时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-date-picker v-model="reservedInfo.reservedPayTime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import {Utils} from '../../app.base'

export default {
    name: 'swb-record-reserved-info',
    desc: '付款单补录凭证号',
    props: ['initReservedPayNo', 'initReservedPayTime'],
    data: function () {
        return {
            reservedInfo: {
                reservedPayNo: null,
                reservedPayTime: null
            }
        }
    },
    created: function () {
        if (!Utils.isNoB(this.initReservedPayNo)) {
            this.reservedInfo.reservedPayNo = this.initReservedPayNo;
        }
        if (!Utils.isNoB(this.initReservedPayTime)) {
            this.reservedInfo.reservedPayTime = this.initReservedPayTime;
        }
    },
    methods: {
        checkNullModel: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('外部付款凭证号不能为空!'));
            } else {
                if (value.length > 30) {
                    callback(new Error('外部付款凭证号最多不能超过30个字!'));
                } else {
                    callback();
                }
            }
        },
        getDlgResult: function () {
            let result = {};
            let reservedInfo = this.reservedInfo || {};
            let reservedPayNo = reservedInfo.reservedPayNo;
            let reservedPayTime = reservedInfo.reservedPayTime;
            if (Utils.isNoB(reservedPayNo)) {
                result.type = "warn";
                result.message = "请输入外部付款凭证号！";
            } else if (!Utils.isNoB(reservedPayNo) && reservedPayNo.length > 30) {
                result.type = "warn";
                result.message = "外部付款凭证号最多不能超过30个字！";
            } else if (Utils.isNoB(reservedPayTime)) {
                result.type = "warn";
                result.message = "请选择外部付款凭证时间！";
            } else {
                result.type = "info";
                result.data = {
                    reservedPayNo: reservedPayNo,
                    reservedPayTime: reservedPayTime
                };
            }
            //
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/payment/RecordReservedInfo.vue